import * as yup from 'yup'
import { i18nTranslate } from 'src/utils'

export const subscriptionNameRegex =
  /^[a-zA-ZÀ-úÀÁÂÃÈÉÊẾÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêếìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ0-9]['a-zA-ZÀ-úÀÁÂÃÈÉÊẾÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêếìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\d!@#$%^&*)(+=._-]*$/
export const schema = () => {
  const regex = subscriptionNameRegex || ''
  const minLengthErrorMessage = i18nTranslate(
    'subscriptionManageHeader.subscriptionNameEditModal.nameIsInvalidValidationErrorMessage',
    'Please enter a valid subscription name',
    { isNextGenTranslations: true }
  )
  const maxLengthErrorMessage = i18nTranslate(
    'subscriptionManageHeader.subscriptionNameEditModal.maxAllowedNameLengthValidationErrorMessage',
    'Max allowed characters is 50',
    { isNextGenTranslations: true }
  )
  const regexErrorMessage = i18nTranslate(
    'subscriptionManageHeader.subscriptionNameEditModal.nameIsInvalidValidationErrorMessage',
    'Please enter a valid subscription name',
    { isNextGenTranslations: true }
  )
  const requiredErrorMessage = i18nTranslate(
    'subscriptionManageHeader.subscriptionNameEditModal.nameIsRequiredValidationErrorMessage',
    'Subscription name is required',
    { isNextGenTranslations: true }
  )
  const schemaData = Object.assign({
    subscriptionName: yup
      .string()
      .required(requiredErrorMessage)
      .min(1, minLengthErrorMessage)
      .max(50, maxLengthErrorMessage)
      .matches(regex, regexErrorMessage),
  })
  return yup.object(schemaData)
}
